import * as CryptoJS from "crypto-js";
import { DEFAULT_PAGINATION_PARAMS, DEFAULT_DASHBOARD_PARAMS } from "./params";

function loginToken(email: string, password: string): string {
  const loginToken = CryptoJS.SHA256(`${email}:${password}`).toString();
  return loginToken;
}

function toQueryString(
  params: Record<string, any>,
  defaultParams?: boolean
): string {
  if (!params) return "";
  const p = defaultParams
    ? { ...DEFAULT_PAGINATION_PARAMS, ...params }
    : params;
  const queryString = Object.entries(p)
    .map(([key, value]) => {
      if (value === undefined) return "";
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .filter(Boolean)
    .join("&");

  return queryString ? `?${queryString}` : "";
}

function toDashboardQueryString(
  params: Record<string, any>,
  defaultParams?: boolean
): string {
  if (!params) return "";
  const p = defaultParams ? { ...DEFAULT_DASHBOARD_PARAMS, ...params } : params;
  const queryString = Object.entries(p)
    .map(([key, value]) => {
      if (value === undefined) return "";
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .filter(Boolean)
    .join("&");

  return queryString ? `?${queryString}` : "";
}

export { loginToken, toQueryString, toDashboardQueryString };
